"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

var _uiKit = require("@dbi-tools/ui-kit");

var _list = require("@dbi-tools/ui-kit/lib/list");

var _clock = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/clock"));

var _useStoreCode2 = require("../../../hooks/use-store-code");

var _useStoreHours2 = require("./use-store-hours");

var _head = require("../../head");

var _const = require("./const");

var _storeHours = require("./store-hours.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClosedMessage = function ClosedMessage() {
  var _useStoreCode = (0, _useStoreCode2.useStoreCode)(),
      data = _useStoreCode.data;

  var userAgent = (0, _uaParserJs.default)(navigator.userAgent);
  var os = userAgent.os.name;
  var isMobile = userAgent.device.type === _uaParserJs.default.DEVICE.MOBILE;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    measure: "sm",
    m: [0],
    color: "primary",
    fontWeight: "light"
  }, "Sorry, this store is closed. Book a", ' ', /*#__PURE__*/_react.default.createElement(_storeHours.LinkStyled, {
    href: _const.RoutePath.BOOK_APPOINTMENT
  }, _const.ClosedStoreCTA.APPOINTMENT), " or", ' ', isMobile && data ? /*#__PURE__*/_react.default.createElement(_storeHours.LinkStyled, {
    href: "sms:".concat(data.storeConfig.store_sms).concat(os === 'iOS' ? '&' : '?', "body=virtual stylist")
  }, _const.ClosedStoreCTA.CHAT) : /*#__PURE__*/_react.default.createElement(_storeHours.ChatButtonStyled, null, /*#__PURE__*/_react.default.createElement(_storeHours.ChatPlaceholderStyled, null, _const.ClosedStoreCTA.CHAT), /*#__PURE__*/_react.default.createElement(_storeHours.CtaWrapStyled, {
    id: "chatstylist"
  })));
};

var TimeTable = function TimeTable(_ref) {
  var hours = _ref.hours;

  var _useStoreHours = (0, _useStoreHours2.useStoreHours)({
    hours: hours
  }),
      timeTable = _useStoreHours.timeTable,
      closedDays = _useStoreHours.closedDays,
      holidays = _useStoreHours.holidays;

  var firstLine = Object.values(timeTable).findIndex(function (value) {
    return value;
  });
  return /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    color: "gray800",
    measure: "sm",
    m: [0, 0, 5, 0],
    fontWeight: "bold"
  }, _const.StoreLocatorStoreListText.TIMETABLE_LABEL), /*#__PURE__*/_react.default.createElement(_list.List, null, Object.keys(timeTable).map(function (label, index) {
    // @ts-ignore
    var time = timeTable[label];

    var isWeekends = _const.weekends.some(function (day) {
      return day.slice(0, 3) === label;
    });

    return (isWeekends || time) && /*#__PURE__*/_react.default.createElement(_storeHours.ListStyled, {
      key: label
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      mr: 5,
      fontWeight: "light",
      color: time ? 'gray800' : 'primary',
      measure: "sm",
      as: "span"
    }, label, ": ", time ? "".concat(time, ";") : 'closed;'), index === firstLine && !!closedDays.length && /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      display: "block",
      key: label,
      fontWeight: "light",
      color: "primary",
      measure: "sm",
      as: "span"
    }, closedDays.join(', '), ": closed;"));
  })), !!holidays.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    color: "primary",
    measure: "sm",
    m: [15, 0, 5, 0],
    fontWeight: "bold"
  }, _const.StoreLocatorStoreListText.TIMETABLE_SPECIAL_LABEL), /*#__PURE__*/_react.default.createElement(_list.List, null, holidays.map(function (_ref2) {
    var label = _ref2.label,
        timetable = _ref2.timetable;
    return /*#__PURE__*/_react.default.createElement(_storeHours.ListStyled, {
      key: label
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      mr: 5,
      fontWeight: "light",
      color: "primary",
      measure: "sm",
      as: "span"
    }, label, ":"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      fontWeight: "light",
      color: "primary",
      measure: "sm",
      as: "span"
    }, timetable, ";"));
  }))));
};

var StoreHours = function StoreHours(_ref3) {
  var hours = _ref3.hours,
      isSmallStyle = _ref3.isSmallStyle,
      initClosed = _ref3.isClosed,
      livePersonID = _ref3.livePersonID;
  var isClosed = initClosed || !hours;
  var livePersonScript = "window.lpTag=window.lpTag||{},'undefined'==typeof window.lpTag._tagCount?(window.lpTag={wl:lpTag.wl||null,scp:lpTag.scp||null,site:'".concat(livePersonID, "'||'',section:lpTag.section||'',tagletSection:lpTag.tagletSection||null,autoStart:lpTag.autoStart!==!1,ovr:lpTag.ovr||{},_v:'1.10.0',_tagCount:1,protocol:'https:',events:{bind:function(t,e,i){lpTag.defer(function(){lpTag.events.bind(t,e,i)},0)},trigger:function(t,e,i){lpTag.defer(function(){lpTag.events.trigger(t,e,i)},1)}},defer:function(t,e){0===e?(this._defB=this._defB||[],this._defB.push(t)):1===e?(this._defT=this._defT||[],this._defT.push(t)):(this._defL=this._defL||[],this._defL.push(t))},load:function(t,e,i){var n=this;setTimeout(function(){n._load(t,e,i)},0)},_load:function(t,e,i){var n=t;t||(n=this.protocol+'//'+(this.ovr&&this.ovr.domain?this.ovr.domain:'lptag.liveperson.net')+'/tag/tag.js?site='+this.site);var o=document.createElement('script');o.setAttribute('charset',e?e:'UTF-8'),i&&o.setAttribute('id',i),o.setAttribute('src',n),document.getElementsByTagName('head').item(0).appendChild(o)},init:function(){this._timing=this._timing||{},this._timing.start=(new Date).getTime();var t=this;window.attachEvent?window.attachEvent('onload',function(){t._domReady('domReady')}):(window.addEventListener('DOMContentLoaded',function(){t._domReady('contReady')},!1),window.addEventListener('load',function(){t._domReady('domReady')},!1)),'undefined'===typeof window._lptStop&&this.load()},start:function(){this.autoStart=!0},_domReady:function(t){this.isDom||(this.isDom=!0,this.events.trigger('LPT','DOM_READY',{t:t})),this._timing[t]=(new Date).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],hooks:lpTag.hooks||[],identities:lpTag.identities||[],ev:lpTag.ev||[]},lpTag.init()):window.lpTag._tagCount+=1;");
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isClosed && /*#__PURE__*/_react.default.createElement(_head.Script, null, livePersonScript), /*#__PURE__*/_react.default.createElement(_storeHours.StoreHoursStyled, null, /*#__PURE__*/_react.default.createElement(_clock.default, {
    color: isClosed ? 'primary' : 'gray800',
    measure: isSmallStyle ? 14 : 18,
    m: isSmallStyle ? [4, 8, 0, 0] : [3, 15, 0, 0]
  }), isClosed || !hours ? /*#__PURE__*/_react.default.createElement(ClosedMessage, null) : /*#__PURE__*/_react.default.createElement(TimeTable, {
    hours: hours
  })));
};

var _default = StoreHours;
exports.default = _default;